import React, { useState, useEffect } from 'react';


import Modal from 'react-modal';

import image2 from './images/cartes/2-avoscotes.webp';
import image4 from './images/cartes/4-rotondes.webp';
import image5 from './images/cartes/5-radioara.webp';
import image7 from './images/cartes/Mir-wellem.png';
import image8 from './images/cartes/8-maskenada.webp';
import image9 from './images/cartes/9-kulturpass.webp';
import image10 from './images/cartes/Trois-CL.png';
import image11 from './images/cartes/11-vollekskichen.webp';
import image12 from './images/cartes/Web-Doktoren.png';
import image14 from './images/cartes/15-gero.webp';
import image15 from './images/cartes/14-digitalinclusion.webp';
import image16 from './images/cartes/17-ententedessocietes.webp';
import image17 from './images/cartes/16-bibliothequeccep.webp';
import image18 from './images/cartes/18-amicaledesfrançais.webp';
import image19 from './images/cartes/19-memoiresenvoyage.webp';
import image21 from './images/cartes/21-bounewegermusek.webp';
import image22 from './images/cartes/22-infomann.webp';
import image24 from './images/cartes/24-bounewegerneuchtigailiercher.webp';
import image25 from './images/cartes/25-danzportclub.webp';
import image33 from './images/cartes/33-lassociazionepassarola.webp';
import image35 from './images/cartes/34-dtunionletzebuerg.webp';
import image36 from './images/cartes/36-cooperationnordsud.webp';
import image37 from './images/cartes/37-tenisclubbonnevoie.webp';
import image45 from './images/cartes/45-fmpo.webp';
import image47 from './images/cartes/Web-medico-social.png';
import image48 from './images/cartes/48-famillecenter.webp';
import image49 from './images/cartes/49-cffm.webp';
import image50 from './images/cartes/50-multi-learn.webp';



import './Carrosel.css';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faCirclePlay, faClose } from '@fortawesome/free-solid-svg-icons';


const Home = () => {
 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState(false);
  const [modalInfoRotondes, setModalInfoRotondes] = useState(false);
  const [modalInfoRadio, setModalInfoRadio] = useState(false);
  const [modalInfoTroiscl, setModalInfoTroiscl] = useState(false);
  const [modalInfoMaskenada, setModalInfoMaskenada] = useState(false);
  const [modalInfoKulturpass, setModalInfoKulturpass] = useState(false);
  const [modalInfoHeemecht, setModalInfoHeemecht] = useState(false);
  const [modalVollekskischen, setModalVollekskischen] = useState(false);
  const [modalDigitalInclusion, setModalDigitalInclusion] = useState(false);
  const [modalGero, setModalGero] = useState(false);
  const [modalCentreCulturel, setModalCentreCulturel] = useState(false);
  const [modalAmicale, setModalAmicale] = useState(false);
  const [modalMusek, setModalMusek] = useState(false);
  const [modalInfoMann, setModalInfoMann] = useState(false);
  const [modalNuech, setModalNuech] = useState(false);
  const [modalDanz, setModalDanz] = useState(false);
  const [modalDtUnion, setModalDtUnion] = useState(false);
  const [modalFMO, setModalFMO] = useState(false);
  const [modalLigueMedico, setModalLigueMedico] = useState(false);
  const [modalFamilljen, setModalFamilljen] = useState(false);
  const [modalInfoMultilearn, setModalInfoMultilearn] = useState(false);
  const [modalMemoires, setModalMemoires] = useState(false);

  const [modalVideo, setModalVideo] = useState(false);


  const handleOpen = () => {
    setIsModalOpen(true);
  };
  const handleInfo = () => {
    setModalInfo(true);
  };
  const handleInfoRotondes = () => {
    setModalInfoRotondes(true);
  };
  const handleInfoRadio = () => {
    setModalInfoRadio(true);
  };
  const handleInfoTroiscl = () => {
    setModalInfoTroiscl(true);
  };
  const handleInfoMaskenada = () => {
    setModalInfoMaskenada(true);
  };
  const handleInfoKulturpass = () => {
    setModalInfoKulturpass(true);
  };
  const handleInfoHeemecht = () => {
    setModalInfoHeemecht(true);
  };
  const handleVollekskischen = () => {
    setModalVollekskischen(true);
  };
  const handleDigitalInclusion = () => {
    setModalDigitalInclusion(true);
  };
  const handleGero = () => {
    setModalGero(true);
  };
  const handleCentreCulturel = () => {
    setModalCentreCulturel(true);

  };
  const handleAmicale = () => {
    setModalAmicale(true);
  };
  const handleMusek = () => {
    setModalMusek(true);
  };
  const handleInfoMann = () => {
    setModalInfoMann(true);
  };
  const handleMemoires = () => {
    setModalMemoires(true);
  };
  const handleNuech = () => {
    setModalNuech(true);
  };
  const handleDanz = () => {
    setModalDanz(true);
  };
  const handleDtUnion = () => {
    setModalDtUnion(true);
  };
  const handleFMO = () => {
    setModalFMO(true);
  };
  const handleLigueMedico = () => {
    setModalLigueMedico(true);
  };
  const handleFamilljen = () => {
    setModalFamilljen(true);
  };
  const handleInfoMultilearn = () => {
    setModalInfoMultilearn(true);

  };



  const handleClose = () => {
    setIsModalOpen(false);
    setModalInfo(false);
    setModalInfoRotondes(false);
    setModalInfoRadio(false);
    setModalInfoTroiscl(false);
    setModalInfoMaskenada(false);
    setModalInfoKulturpass(false);
    setModalInfoHeemecht(false);
    setModalVollekskischen(false);
    setModalDigitalInclusion(false);
    setModalGero(false);
    setModalCentreCulturel(false);
    setModalAmicale(false);
    setModalMusek(false);
    setModalInfoMann(false);
    setModalNuech(false);
    setModalDanz(false);
    setModalDtUnion(false);
    setModalFMO(false);
    setModalLigueMedico(false);
    setModalFamilljen(false);
    setModalInfoMultilearn(false);
    setModalMemoires(false);


  };
 
  



 const  handleHomeModalVideo =()=>{
  setModalVideo(true);

  }
  const handleCloseModalVideo = ()=>{
    setModalVideo(false);
  }

  return (
    <>
              
    

     <div className='envelope-home'>

        <div className="grid-container-home">

            <div className="grid-item-home" id="grid1-home">
            <button className="link-test">
            </button>
            <img src={image2} alt=" À vos côtés" />
        
           
            <div className='link-home'>
          <a href="https://inter-actions.lu/type_portfolio/avoscotes-2/"  aria-label="Site A Vos Cotes" target="_blank" rel="noopener noreferrer">
          </a>
          </div>
          </div>

   
            <div className="grid-item-home" id='grid3-home'>

       
              <img src={image4} alt='Rotondes' />

      

              <div className="link-home">
             <a href="https://www.rotondes.lu/" aria-label="Site rotondes" target="_blank" rel="noopener noreferrer"></a>
          </div>

            </div>

            <div className="grid-item-home" id='grid4-home'>
            <button className='play'><FontAwesomeIcon icon={faCirclePlay} className='play-icon' onClick={handleInfoRadio}/></button>



              <img src={image5} alt='Radio Ara' />
              <Modal
            isOpen={modalInfoRadio}
            onRequestClose={() => setModalInfoRadio(false)}
            className="modal-content-video"
            overlayClassName="modal-overlay"
            ariaHideApp={false}
          >
             <div className='close-modal-home'><FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                          </div>

            <div className="title-video"><h2>Radio ARA</h2></div>
            <div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/o4YKQ5pHxnA?si=9NKSVIvBylhO04uN" 
            allowFullScreen></iframe>
              </div>
          </Modal> 

              
              
          

              <div className="link-home" id='link-2'>
             <a href="https://aracityradio.com/" target="_blank" rel="noopener noreferrer"></a>
          </div>
    
              
            </div>


            <div className="grid-item-home" id='grid5-home'>
              <img src={image7} alt='Mir wellen Iech oons weisen' />
              <div className="link-home" id='link-2'>
              <a href="https://onsheemecht.lu/" target="_blank" rel="noopener noreferrer"></a>

  
          </div>


            </div>
            <div className="grid-item-home" id='grid6-home'>
              <img src={image8} alt='Maskénada' />
              <div className="link-home">
             <a href="https://www.maskenada.lu/" target="_blank" rel="noopener noreferrer"></a>
          </div>
          
              <Modal
                isOpen={modalInfoMaskenada}
                onRequestClose={() => setModalInfoMaskenada(false)}
                className="modal-content"
                overlayClassName="modal-overlay"
                ariaHideApp={false}
              >
                              <button className='btn-close' onClick={handleClose}>X</button>

                <div className='info-box'>
                  <div className='img-box'><img src={image8} alt="info-radio" className="info-img" />
                  </div>

                  <div className='text-box'>
                    <h2>MASKéNADA</h2>
                    <p>Plus d'information :  <div className='link-info'><a href='https://www.maskenada.lu/'>Site</a></div></p>
                  </div>

                </div>
              </Modal>
            
            </div>

            <div className="grid-item-home" id='grid7-home'>
              <img src={image9} alt='grid9' />
              <div className="link-home">
             <a href="https://www.kulturpass.lu/fr/" target="_blank" rel="noopener noreferrer"></a>
          </div>
            </div>

            <div className="grid-item-home" id='grid8-home'>
             <img src={image10} alt='Trois CL' />

           
              <div className="link-home">
              <a href="https://www.danse.lu/" target="_blank" rel="noopener noreferrer"></a>
       
             
          </div>
            </div>

            <div className="grid-item-home" id='grid9-home'>
              <img src={image11} alt='Vollekskichen' />
              <div className="link-home">
             <a href="https://www.cnds.lu/vollekskichen" target="_blank" rel="noopener noreferrer"></a>
          </div>         
            </div>

            <div className="grid-item-home" id='grid10-home'>
              <img src={image12} alt='Doktoren vun der Welt' />
              <div className="link-home">
             <a href="https://medecinsdumonde.lu/" target="_blank" rel="noopener noreferrer"></a>
          </div>         
            </div>
            <div className="grid-item-home" id='grid11-home'>
              <img src={image14} alt='Gero' />
              <div className="link-home">
              <a href="https://www.gero.lu/" target="_blank" rel="noopener noreferrer"></a>
              </div>         
            </div>

        
            <div className="grid-item-home" id='grid12-home'>
            <div className="car4"></div>
            <img src={image15} alt='Digital Inclusion' />
              <div className="link-home" id='link-12'>
             <a href="https://digital-inclusion.lu/" target="_blank" rel="noopener noreferrer"></a>
          </div>
    
          
            </div>
            {/*grid 13*/}
            <div className="grid-item-home" id='grid13-home'>
              <img src={image16} alt='Entente des sociétés' />
              <div className="link-home" id='link-13'>
              <a href="https://www.bonnevoie.info/" target="_blank" rel="noopener noreferrer"></a>
              </div>

            </div>
            {/*grid 14*/}
            <div className="grid-item-home" id='grid14-home'>
              <img src={image17} alt='Bibliothèque CCEP' />
              <div className="link-home" id='link-14'>
             <a href="https://www.ccep-bonnevoie.lu/" target="_blank" rel="noopener noreferrer"></a>
          </div>
 
            </div>
            {/*grid 15*/}
            <div className="grid-item-home" id='grid15-home'>
            <button className='play'><FontAwesomeIcon icon={faCirclePlay} className='play-icon' onClick={handleAmicale}/></button>

              <img src={image18} alt='Amicale des Français' />
              <Modal
            isOpen={modalAmicale}
            onRequestClose={() => setModalAmicale(false)}
            className="modal-content-video"
            overlayClassName="modal-overlay"
            ariaHideApp={false}
          >
             <div className='close-modal-home'><FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                          </div>
                          
            <div className="title-video">
            <h2>Amicale des Français à Luxembourg</h2>

            </div>
            <div>
              <iframe width="560" height="315" src="https://www.youtube.com/embed/HLZRqDpd2m4?si=Loh8HJ_zyIxHuqrS" allowFullScreen></iframe>
                 </div>
          </Modal> 

              <div className="link-home" id='link-15' >
             <a href="https://www.afalux.eu/.lu/" target="_blank" rel="noopener noreferrer"></a>
          </div>
            </div>
           
            <div className="grid-item-home" id='grid16-home'>
            <button className='play'><FontAwesomeIcon icon={faCirclePlay} className='play-icon' onClick={handleMemoires}/></button>

              <img src={image19} alt='Mémoires en voyage' />
              <Modal
            isOpen={modalMemoires}
            onRequestClose={() => setModalMemoires(false)}
            className="modal-content-video"
            overlayClassName="modal-overlay"
            ariaHideApp={false}
          >
             <div className='close-modal-home'><FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                          </div>

            <div className="title-video">
            <h2>Mémoires en voyage</h2>

            </div>
            <div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/SqScJMdoeG0?si=FcpMwMm9oxzy0_de" 
            allowFullScreen></iframe>            
                 </div>
          </Modal> 
              
              <div className="link-home" id='link-16' >
             <a href="https://memoiresenvoyage.my.canva.site/" target="_blank" rel="noopener noreferrer"></a>
          </div>
            </div>

            <div className="grid-item-home" id='grid17-home'>
              <img src={image21} alt='Bouneweger Musek' />
              <div className="link-home" id='link-17' >
             <a href="https://www.fmlb.lu/" target="_blank" rel="noopener noreferrer"></a>
          </div>
            </div>

         
            <div className="grid-item-home" id='grid18-home'>
            <button className='play'><FontAwesomeIcon icon={faCirclePlay} className='play-icon' onClick={handleInfoMann}/></button>
  
            
              <img src={image22} alt='InfoMann' />
              <div className="link-home" id='link-18' >
             <a href="http://www.infomann.lu/" target="_blank" rel="noopener noreferrer"></a>
          </div>
          <Modal
            isOpen={modalInfoMann}
            onRequestClose={() => setModalInfoMann(false)}
            className="modal-content-video"
            overlayClassName="modal-overlay"
            ariaHideApp={false}
          >
             <div className='close-modal-home'><FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                          </div>

             <div className="title-video">
            <h2>InfoMann</h2>
            </div>
            <div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/-39SsPD1BOo?si=MLEuvmMO7ObACfpH"  
            allowFullScreen></iframe>
            </div>
          </Modal> 
            </div>
         
            <div className="grid-item-home" id='grid19-home'>
              <img src={image24} alt='B. Nuechtigailercher' />
              <div className="link-home" id='link-19' >
             <a href="https://www.bng.lu/" target="_blank" rel="noopener noreferrer"></a>
          </div>
            </div>

            <div className="grid-item-home" id='grid20-home'>
            <button className='play'><FontAwesomeIcon icon={faCirclePlay} className='play-icon' onClick={handleDanz}/></button>

              <img src={image25} alt='Danzsportclub RWB' />
              <Modal
            isOpen={modalDanz}
            onRequestClose={() => setModalDanz(false)}
            className="modal-content-video"
            overlayClassName="modal-overlay"
            ariaHideApp={false}
          >
             <div className='close-modal-home'><FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                          </div>

           <div className="title-video">
           <h2>Danzsportclub Rout-Wäiss-Blo Lëtzebuerg</h2>
            </div> 
            <div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/CBIkxI6vWrA?si=j6DT6u9zJ-X0w6RT" 
            allowfullScreen></iframe>
            </div>
          </Modal> 

              
              <div className="link-home" id='link-20' >
             <a href="https://www.dancesport.lu/" target="_blank" rel="noopener noreferrer"></a>
             </div>
          </div>
     

          <div className="grid-item-home" id='grid22-home'>
              <img src={image33} alt='L Associazione PassaParola' />
              <div className="link-home" id='link-22' >
             <a href="https://passaparola.info/web/" target="_blank" rel="noopener noreferrer"></a>
          </div>
          </div>

          <div className="grid-item-home" id='grid23-home'>
          <button className='play'><FontAwesomeIcon icon={faCirclePlay} className='play-icon' onClick={handleDtUnion}/></button>

              <img src={image35} alt='DT Union'/>
              <Modal
            isOpen={modalDtUnion}
            onRequestClose={() => setModalDtUnion(false)}
            className="modal-content-video"
            overlayClassName="modal-overlay"
            ariaHideApp={false}
          >
             <div className='close-modal-home'><FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                          </div>

           <div className="title-video">
           <h2>Dësch-Tennis UNION Lëtzebuerg</h2>

            </div> 
            <div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/hTbYa9SJHAE?si=J-UL5p63aDB5zDbx" 
            allowfullScreen></iframe>            </div>
          </Modal> 

              <div className="link-home" id='link-23' >
              <a href="https://www.dtunion.lu/" target="_blank" rel="noopener noreferrer"></a>
              </div>
              </div>
   
          <div className="grid-item-home" id='grid24-home'>
              <img src={image36} alt='Coordination Nord-Sud'/>
              <div className="link-home" id='link-24' >
              <a href="https://www.cns-asbl.org/"target="_blank" rel="noopener noreferrer"></a>

          </div>
          </div>

          <div className="grid-item-home" id='grid25-home'>
              <img src={image37} alt='Tennis Club Bonnevoie'/>
              <div className="link-home" id='link-25' >
             <a href="https://www.tcbonnevoie.com/"target="_blank" rel="noopener noreferrer"></a>
          </div>
          </div>

          <div className="grid-item-home" id='grid26-home'>
              <img src={image45} alt='FMPO'/>
              <div className="link-home" id='link-26' >
              <a href="https://www.fmpo.lu/" target="_blank" rel="noopener noreferrer"></a>
              </div>
              </div>
   
          <div className="grid-item-home" id='grid27-home'>
              <img src={image47} alt='Ligue Médico-Sociale'/>
              <div className="link-home" id='link-27' >
             <a href="https://ligue.lu" target="_blank" rel="noopener noreferrer"></a>
             </div>
          </div>
          <div className="grid-item-home" id='grid28-home'>
              <img src={image48} alt='Familljen-Center'/>
              <div className="link-home" id='link-28' >
             <a href="https://www.familljen-center.lu/" target="_blank" rel="noopener noreferrer"></a>
             </div>


          </div>
          <div className="grid-item-home" id='grid30-home'>
              <img src={image49} alt='Centre pour Femmes, Familles et Familles Monoparentales'/>
              <div className="link-home" id='link-30' >
             <a href="https://fed.lu/wp/services/cffm/" target="_blank" rel="noopener noreferrer"></a>
             </div>
          </div>
          <div className="grid-item-home" id='grid31-home'>
              <img src={image50} alt='Multi-Learn'/>
              <div className="link-home" id='link-31' >
              <a href="https://multi-learn.org/" target="_blank" rel="noopener noreferrer"></a>
          </div>
        </div>
      
      </div>
    
   
</div>


    </>

  );
};

export default Home;